const API_BASE_URL = 'https://glitter-backend-six.vercel.app';

export const FILTER_ENDPOINT = `${API_BASE_URL}/filter-endpoint/`;
